export const screenSizes = {
  sm: 375,
  md: 768,
  lg: 1024,
  xl: 1280,
  xxl: 1440,
  '3xl': 1728,
} as const;

export const mediaQueries = {
  sm: `(min-width: ${screenSizes.sm}px)`,
  md: `(min-width: ${screenSizes.md}px)`,
  lg: `(min-width: ${screenSizes.lg}px)`,
  xl: `(min-width: ${screenSizes.xl}px)`,
  xxl: `(min-width: ${screenSizes.xxl}px)`,
  '3xl': `(min-width: ${screenSizes['3xl']}px)`,
};
